import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHistoryClockwise = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8.48876 3.7187V8.87845L6.32508 11.6635C6.12454 11.9216 6.17136 12.2934 6.4294 12.4939C6.53728 12.5777 6.66511 12.6184 6.79196 12.6184C6.96839 12.6184 7.14305 12.5398 7.25962 12.3898L9.54797 9.44432C9.62859 9.34059 9.67245 9.21275 9.67245 9.08117V3.7187C9.67245 3.39191 9.4075 3.12695 9.0807 3.12695C8.75371 3.12695 8.48876 3.39191 8.48876 3.7187Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1484 2.15933L15.7041 3.2061C14.0257 1.19041 11.5091 0 8.876 0C3.98179 0 0 3.98179 0 8.876C0 13.7704 3.98179 17.752 8.876 17.752C9.72677 17.752 10.5683 17.6319 11.3769 17.3948C11.6905 17.3029 11.8703 16.9741 11.7784 16.6606C11.6863 16.3468 11.357 16.1676 11.0442 16.2591C10.3436 16.4644 9.61415 16.5687 8.8762 16.5687C4.63439 16.5685 1.18349 13.1178 1.18349 8.876C1.18349 4.63419 4.63439 1.18349 8.876 1.18349C11.1673 1.18349 13.2784 2.16862 14.7437 3.90217L13.2332 4.99695C12.9453 5.20559 13.0534 5.65824 13.4045 5.71416L16.3302 6.18103C16.7967 6.25552 17.2353 5.93762 17.3098 5.47114L17.7767 2.5454C17.8328 2.19411 17.4363 1.95049 17.1484 2.15933Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9685 13.1998C15.7027 13.01 15.3331 13.0722 15.1432 13.3381C14.717 13.9354 14.2084 14.4689 13.6311 14.9235C13.3743 15.1258 13.33 15.4977 13.5321 15.7545C13.6489 15.9029 13.8224 15.9803 13.9974 15.9803C14.1255 15.9803 14.2547 15.9389 14.3629 15.8537C15.0288 15.3295 15.6154 14.7143 16.1066 14.0253C16.2966 13.759 16.2348 13.3895 15.9685 13.1998Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.1602 8.28516C16.8334 8.28516 16.5685 8.55011 16.5685 8.8769C16.5685 9.49058 16.4962 10.1011 16.3535 10.6913C16.2767 11.009 16.4721 11.3286 16.7896 11.4055C16.8364 11.417 16.883 11.4223 16.9291 11.4223C17.196 11.4223 17.4384 11.2403 17.5038 10.9695C17.6686 10.2884 17.752 9.58423 17.752 8.8769C17.752 8.55011 17.4872 8.28516 17.1602 8.28516Z",
			fill: "currentColor"
		})
	]
});
export default SvgHistoryClockwise;
